var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 38,
    viewBox: "0 0 36 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.196 37.0682L15.7074 23.0057L3.81818 30.5483L0.75 25.179L13.2784 18.6591L0.75 12.1392L3.81818 6.76989L15.7074 14.3125L15.196 0.25H21.3324L20.821 14.3125L32.7102 6.76989L35.7784 12.1392L23.25 18.6591L35.7784 25.179L32.7102 30.5483L20.821 23.0057L21.3324 37.0682H15.196Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSymbol);
export default __webpack_public_path__ + "static/media/star_symbol.c1527ecbcaa8228aa7d18ce0d36e3e3c.svg";
export { ForwardRef as ReactComponent };